import { render, staticRenderFns } from "./batch-ok.vue?vue&type=template&id=71aef392&scoped=true"
import script from "./batch-ok.vue?vue&type=script&lang=js"
export * from "./batch-ok.vue?vue&type=script&lang=js"
import style0 from "./batch-ok.vue?vue&type=style&index=0&id=71aef392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aef392",
  null
  
)

export default component.exports